import GiftModal from './send-as-gift';
import NotReturnableModal from './not-returnable';
import ParallelImportModal from './parallel-import';
import SizeChartModal from './size-chart';

export { GiftModal };
export { NotReturnableModal };
export { ParallelImportModal };
export { SizeChartModal };
